import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUpStroke = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160 632L458 310C471 296 485 290 500 290C515 290 528 295 542 310L836 628C877 672 863 718 812 718H188C140 718 122 676 160 632ZM250 646H750L500 375Z" })
});
export default SvgCaretUpStroke;
